import './index.css'

import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { FirebaseProvider } from './firebase/FirebaseProvider'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Could not find root element')
}

const root = createRoot(rootElement)

// Animation harness (?test=animations). Available in production too — it is
// only reachable via the explicit query param. The module (and its CSS) is
// dynamically imported, so it stays a separate chunk that is fetched only when
// the param is present, never weighing down the main app. It is also mounted
// outside FirebaseProvider, so it needs no auth or Firestore.
const params = new URLSearchParams(window.location.search)
if (params.get('test') === 'animations') {
  void import('./dev/AnimationTestPage').then(({ AnimationTestPage }) => {
    root.render(
      <React.StrictMode>
        <AnimationTestPage />
      </React.StrictMode>,
    )
  })
} else {
  root.render(
    <React.StrictMode>
      <FirebaseProvider>
        <App />
      </FirebaseProvider>
    </React.StrictMode>,
  )
}
